// Spiegel von src/modules/product-knowledge/steckbrief.ts: STECKBRIEF_FELDER.
// Bei Änderungen am Backend-Vertrag diese Liste und die Hilfetexte gemeinsam pflegen.
export const STECKBRIEF_FELDER = [
  'beschreibung', 'bildart', 'ansicht', 'teile', 'variante', 'oberflaeche',
  'hintergrund', 'text_logo', 'notiz_generierung',
] as const

export const FELDHILFE: Record<string, { titel: string; text: string; agent: string }> = {
  bilder: {
    titel: 'Bilder',
    text: 'Hier werden die Bildverwendungen dieses Artikels verwaltet. Bis zu zwölf Bilder können hochgeladen, angeordnet und als Hauptbild gesetzt werden; Entfernen löst nur die Verwendung, das Bild bleibt im Archiv.',
    agent: 'JPEG, PNG oder WebP bis 15 MB hinzufügen, z. B. ein Produktfoto oder eine Maßzeichnung. Ohne passende Bilddatei leer lassen; maximal zwölf Verwendungen je Artikel.',
  },
  verwendung: {
    titel: 'Verwendung',
    text: 'Die Verwendung legt Rolle, Portale und die optionale Varianten-SKU für diesen Artikel fest. Der Steckbrief beschreibt dagegen das Bild selbst.',
    agent: 'Rolle als Enum, Portale als Liste und Varianten-SKU als Zeichenfolge setzen, z. B. detail, [amazon, ebay], *7527. Unbekannte optionale Angaben leer lassen; Rolle ist Pflicht.',
  },
  steckbrief: {
    titel: 'Steckbrief',
    text: 'Der Steckbrief beschreibt den sichtbaren Bildinhalt und zeigt die Quelle jedes vorhandenen Werts. Manuelle Änderungen bleiben bei späteren automatischen Füllungen erhalten; das Leeren eines vorhandenen Werts wird als bewusste manuelle Löschung gespeichert.',
    agent: 'Nur sichtbare oder belegte Eigenschaften als Text eintragen, z. B. ansicht=vorne oder oberflaeche=matt. Unbekanntes leer lassen; vorhandene Werte nur bei belegter Korrektur ändern und nur auf ausdrücklichen Wunsch leeren.',
  },
  rolle: {
    titel: 'Rolle',
    text: 'Hauptbild (haupt) zeigt das Produkt zuerst; für Amazon ist ein Freisteller auf weißem Hintergrund mit mindestens 1000 px je Seite und ohne Text oder Logo erforderlich. Nebenbild (neben) ergänzt die Gesamtansicht, Detailbild (detail) zeigt Einzelheiten, Maße (masse) die Abmessungen, Anwendung (anwendung) den Einsatz und Verpackung (verpackung) die Verpackung.',
    agent: 'Genau einen Wert aus haupt|neben|detail|masse|anwendung|verpackung wählen, z. B. masse für eine Maßzeichnung oder detail für eine Nahaufnahme. Bei unklarer Eignung kein Hauptbild behaupten; die Pflichtrolle vor dem Speichern klären.',
  },
  portale: {
    titel: 'Portale',
    text: 'Mehrere Portale können ausgewählt werden. Ohne Einschränkung gilt das Bild für alle Portale; die Auswahl veröffentlicht das Bild noch nicht.',
    agent: 'Portalschlüssel als Liste angeben, z. B. amazon,ebay oder shopify. Ohne belegte Einschränkung leer lassen, dann gilt das Bild für alle Portale.',
  },
  variant_sku: {
    titel: 'Varianten-SKU',
    text: 'Die Varianten-SKU ordnet diese Bildverwendung einer bestimmten Artikelvariante zu. Ohne Zuordnung gilt die Verwendung für den Artikel insgesamt.',
    agent: 'Exakte bekannte SKU als Text mit maximal 100 Zeichen eintragen, z. B. *7527 oder DR-7527-400. Ohne eindeutige Zuordnung leer lassen; keine SKU aus dem Bild erfinden.',
  },
  seo_name: {
    titel: 'SEO-Name',
    text: 'Der Name ist Teil der öffentlichen Bild-URL und wird nur beim Hochladen vergeben. Er besteht aus 3 bis 80 Kleinbuchstaben, Ziffern und Bindestrichen; der Vorschlag lässt sich vor dem Hochladen bearbeiten.',
    agent: 'Beschreibung und Artikelname zu 3–80 Zeichen aus [a-z0-9-] verbinden, Umlaute ae/oe/ue und ß als ss schreiben, z. B. moebelfuss-vorne oder tuergriff-matt. Bei fehlender Beschreibung den belegten Artikelnamen verwenden; nach Upload unverändert lassen.',
  },
  beschreibung: {
    titel: 'Beschreibung',
    text: 'Eine kurze sachliche Beschreibung benennt das sichtbare Produkt und die Besonderheit dieser Aufnahme. Werbeaussagen und nicht sichtbare Eigenschaften gehören nicht in den Bildtext.',
    agent: 'Kurzen deutschen Klartext eintragen, z. B. „Möbelfuß aus Metall, Vorderansicht“ oder „Verpackung mit vier Füßen“. Ohne erkennbaren Bildinhalt leer lassen; maximal 2000 Zeichen.',
  },
  bildart: {
    titel: 'Bildart',
    text: 'Die Bildart beschreibt die Darstellungsform, etwa Freisteller, Detailaufnahme oder Maßzeichnung. Ein Freisteller zeigt das Produkt ohne Umgebung.',
    agent: 'Kurzen Text verwenden, z. B. freisteller oder masszeichnung; für einen belegten Freisteller exakt freisteller schreiben. Wenn die Darstellungsform unbekannt ist, leer lassen; maximal 2000 Zeichen.',
  },
  ansicht: {
    titel: 'Ansicht',
    text: 'Die Ansicht bezeichnet die Blickrichtung auf das Produkt. Beispiele sind vorne, hinten, seitlich oder von oben.',
    agent: 'Blickrichtung als kurzen Text eintragen, z. B. vorne oder seitlich links. Bei nicht erkennbarer Orientierung leer lassen; maximal 2000 Zeichen.',
  },
  teile: {
    titel: 'Teile',
    text: 'Hier werden die sichtbar abgebildeten Teile und ihre Anzahl beschrieben. Die Anzahl im Bild kann vom Lieferumfang abweichen.',
    agent: 'Sichtbare Stücke als Text nennen, z. B. „4 Füße und 16 Schrauben“ oder „1 Griff“. Nicht sichtbaren Lieferumfang nicht ergänzen; bei unklarer Anzahl leer lassen; maximal 2000 Zeichen.',
  },
  variante: {
    titel: 'Variante',
    text: 'Die Variante beschreibt die im Bild erkennbare Ausführung, zum Beispiel Größe oder Farbe. Die Zuordnung über eine Artikelnummer erfolgt getrennt über die Varianten-SKU.',
    agent: 'Belegte Ausführung als Text nennen, z. B. „400 mm, schwarz“ oder „250 mm“. Ohne belegte Unterscheidungsmerkmale leer lassen; maximal 2000 Zeichen.',
  },
  oberflaeche: {
    titel: 'Oberfläche',
    text: 'Die Oberfläche beschreibt die erkennbare Beschaffenheit oder Veredelung des Produkts. Eine nicht belegbare Materialart soll daraus nicht abgeleitet werden.',
    agent: 'Sichtbare oder belegte Oberfläche kurz beschreiben, z. B. matt oder gebürstet. Bei unklarer Beschaffenheit leer lassen; maximal 2000 Zeichen.',
  },
  hintergrund: {
    titel: 'Hintergrund',
    text: 'Der Hintergrund beschreibt die Umgebung hinter dem Produkt. Für ein Amazon-Hauptbild ist ein weißer Hintergrund erforderlich.',
    agent: 'Kurzen Klartext verwenden, z. B. weiß oder Werkbank. Ohne sichtbaren oder eindeutig bestimmbaren Hintergrund leer lassen; maximal 2000 Zeichen.',
  },
  text_logo: {
    titel: 'Text / Logo',
    text: 'Hier wird festgehalten, ob Text, Logos oder Wasserzeichen sichtbar sind. „nein“ bedeutet, dass keine solchen Elemente erkennbar sind.',
    agent: 'Bei geprüftem Fehlen exakt nein schreiben, sonst sichtbare Elemente benennen, z. B. „Maßangaben und Stahlia-Logo“. Wenn nicht geprüft, leer lassen; maximal 2000 Zeichen.',
  },
  notiz_generierung: {
    titel: 'Notiz zur Generierung',
    text: 'Diese Notiz hält Angaben zur Erzeugung oder Bearbeitung des Bildes fest. Sie wird ausschließlich manuell gepflegt.',
    agent: 'Belegte Entstehungs- oder Bearbeitungshinweise als Text erfassen, z. B. „Hintergrund entfernt“ oder „KI-Entwurf, Produktform prüfen“. Ohne bekannte Bearbeitung oder Generierung leer lassen; maximal 5000 Zeichen.',
  },
}
